import { getLocalStorageObjectItem } from '@manigo/manigo-commons';

import { defaultLocale, selectedLanguageStorageKay } from 'config/config';


export function getStoredLanguage() {
    return getLocalStorageObjectItem(selectedLanguageStorageKay) || defaultLocale;
}
